<div class="qr-error-manual">
  <div class="qr-error-manual__content">
    <app-header />

    <div class="qr-error-manual__main">
      <section class="qr-error-manual__message" aria-labelledby="qr-error-manual-title">
        <img
          class="qr-error-manual__icon"
          src="assets/img/icon-error.svg"
          alt=""
          width="110"
          height="110"
          aria-hidden="true"
        />
        <h1 id="qr-error-manual-title" class="qr-error-manual__title">{{ copy().title }}</h1>
        <p class="qr-error-manual__subtitle">
          {{ copy().subtitle }}
        </p>
      </section>

      <section class="qr-error-manual__action" aria-label="Identification manuelle">
        <div class="qr-error-manual__manual-card">
          <app-identification-card
            variant="manual"
            [title]="manualCardTitle"
            subtitle=""
            illustrationSrc="assets/img/icon-illustration-manual-keypad.svg"
            illustrationAlt="Main pointant vers un clavier numérique"
            (pressed)="identifyManually()"
          />
        </div>
      </section>
    </div>

    <app-footer>
      <app-footer-nav [showScrollButton]="false" [backRoute]="scanRoute" />
    </app-footer>
  </div>
</div>
